const serviceAreas = {
  serviceAreas: {
    pageHeader: 'Aree dei servizi',
    description:
      "Quando un proprietario di casa cerca gli installatori Enphase in una particolare area, utilizzeremo la %{regionOrCountyLabel} da te inserita qui per verificare se per te è disponibile un servizio in quell'area.",
    addNewArea: 'Aggiungi nuova area',
    new: 'Nuovo',
    areaName: 'Nome area',
    servicesCovered: {
      countiesCovered: 'Province coperte',
      regionsCovered: 'Regioni coperte',
      provincesCovered: 'Province coperte',
      regionsWithCount: '%{region}(prime %{typeCharacters} cifre del CAP) coperte',
      districtsCovered: 'Distretti coperti',
      citiesCovered: 'Comuni coperte',
      citiesCoveredbr: 'Città coperte',
      departments: 'reparti',
      regions: 'regioni',
      counties: 'province',
      districts: 'distretti',
      cities: 'comuni',
      provinces: 'Province',
      city: 'città'
    },
    selectAllCounty: 'Seleziona tutte le %{regionOrCountyLabel} di uno stato specifico',
    selectAllCountyWithRegion: 'Seleziona tutte le %{regionOrCountyLabel} Da una regione specifica',
    selectAllDepartment: 'Seleziona tutti i reparti',
    addCountiesRegionsButton: 'Aggiungi %{regionOrCountyLabel}',
    countyButtonDescription:
      'In base allo stato selezionato, verranno aggiunte tutte le %{regionOrCountyLabel} correlate',
    countyButtonDescriptionWithRegion: 'In base allo region selezionato, verranno aggiunte tutte le %{regionOrCountyLabel} correlate',
    area1: 'AREA 1',
    selectState: 'Seleziona stato',
    selectRegion: 'Seleziona Regione',
    requestNotProcessed: 'Non è stato possibile elaborare la richiesta',
    footerTitle:
      'Il prezzo indicativo dovrebbe includere i costi per installazione, montaggio in rack, modulo PV, inverter, ecc. I costi come tetto, aggiornamento pannello principale possono essere aggiuntivi',
    footerBody:
      'Enphase fornirà questo prezzo indicativo al proprietario di casa. Enphase fornirà al proprietario di casa un esonero di responsabilità riguardo al fatto che questo prezzo è preliminare e soggetto a modifiche.',
    noBlankRegions: 'Il campo %{regionOrCountyLabel} coperte non può essere lasciato vuoto',
    //noBlankCounties: 'Il campo Province coperte non può essere lasciato vuoto',
    deleteConfirmation: 'Sei sicuro di voler eliminare questa area servizi?',
    ok: 'Ok',
    infoText: `%{bTagOpen}Region%{bTagClose} è definita come le prime %{count} cifre di un CAP in un %{stateOrProvince}`,
    infoTextFr: `Il reparto è definito in base alle prime 2 cifre del codice postale`,
    state: 'stato',
    province: 'provincia',
    noOptions: 'Nessuna opzione'
  }
};

export default serviceAreas;
